"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _propTypes2 = require("FileManagerCore/constants/propTypes");

var InsertButton = function InsertButton(_ref) {
  var file = _ref.file,
      onInsert = _ref.onInsert;
  var isInsertDisabled = Boolean(file.get('notSupported'));

  var button = _react.default.createElement(_UIButton.default, {
    className: "m-right-6",
    use: "primary",
    onClick: onInsert,
    disabled: isInsertDisabled,
    "data-test-id": "file-detail-insert-button"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "FileManagerLib.actions.insert"
  }));

  if (isInsertDisabled) {
    return _react.default.createElement(_UITooltip.default, {
      title: file.get('notSupportedReason'),
      "data-test-id": "file-detail-insert-disabled-tooltip"
    }, button);
  }

  return button;
};

InsertButton.propTypes = {
  file: _propTypes2.mapProp.isRequired,
  onInsert: _propTypes.default.func.isRequired
};
var _default = InsertButton;
exports.default = _default;
module.exports = exports.default;